import I18n from 'I18n';
import CopilotActionButton from 'ai-components-ui-library/components/buttons/CopilotActionButton';
import { OBJECT_SUMMARY } from 'copilot-toolkit/constants/CopilotInAppActionTypes';
import { useMemo } from 'react';
import { getUsageTracker } from 'EmailComponents/utils/tracking';
import { MARKETING_EMAIL_OBJECT_TYPE } from 'email-management-lib/Shared/constants/frameworkTable';
import { jsx as _jsx } from "react/jsx-runtime";
const getCopilotAction = (emailId, objectName) => {
  return {
    label: I18n.text('email-management.marketingInsightsCopilotButton.label'),
    objectId: emailId,
    intent: OBJECT_SUMMARY,
    objectTypeId: MARKETING_EMAIL_OBJECT_TYPE,
    objectTypeLabel: I18n.text('email-management.marketingInsightsCopilotButton.objectTypeLabel'),
    objectName
  };
};
export const MarketingInsightsCopilotButton = ({
  emailId,
  objectName
}) => {
  const copilotAction = useMemo(() => getCopilotAction(emailId, objectName), [emailId, objectName]);
  return /*#__PURE__*/_jsx(CopilotActionButton, {
    copilotAction: copilotAction,
    text: I18n.text('email-management.marketingInsightsCopilotButton.label'),
    useBreezeStyles: false,
    usageTracker: getUsageTracker()
  });
};